import { createContext, useContext } from "react";

import type { UserProviderResults } from "./types";

export const UserContext = createContext({} as UserProviderResults);

export const useUser = () => useContext(UserContext);
